<template>
  <div class="sds-downloads" :class="{ visible: !!material, pinned: pinned }" :data-id="material.number">
    <div class="close-panel" @click="onClose" v-if="!pinned"></div>
    <div class="title" v-if="!pinned">
      <span>{{ labels.availableSdsFiles }}</span>&nbsp;
      <span>{{ this.$props.material.name }}</span>
    </div>
    <div class="container" v-if="filteredFiles && filteredFiles.length > 0">
      <div class="best-item-disclaimer" v-if="bestFile">{{ labels.bestSdsFile }}</div>
      <download-file :file="bestFile" v-if="bestFile" :only-item="true" class="best-file"></download-file>
      <div class="alternatives-disclaimer" v-if="files && (files.length > (bestFile ? 1 : 0))">
        <span v-if="!bestFile">{{ labels.noBestFile }} </span>
        {{ labels.alternativeSdsFiles }}
      </div>
      <DropList :data="regions" v-model="currentRegion" @change="onRegionChanged" :label="labels.currentRegion">
      </DropList>
      <div class="file-container" v-if="filteredFiles && filteredFiles.length > 0">
        <download-file v-for="file in filteredFiles" :key="file.id" :file="file" :parent-number="material.number"
          :parent-name="material.name"></download-file>
      </div>
    </div>
    <div class="no-files" v-if="!loading && (!filteredFiles || filteredFiles.length === 0)" v-html="labels.noSDSFiles">
    </div>
  </div>
</template>

<script>
import Labels from "../services/labels.js";
import Utils from "../services/utils.js";
import DataLayer from "../services/datalayer.js";
import DownloadFile from "./DownloadFile.vue";
import { DropList } from "clariant-vue3-forms";

export default {
  name: "SDSDownloads",
  components: {
    DownloadFile,
    DropList
  },
  props: ["material", "pinned"],
  data() {
    return {
      labels: Labels,
      bestFile: null,
      files: null,
      loading: false,
      regions: [],
      currentRegion: null,
      filteredFiles: null
    };
  },
  mounted() {
    this.loadFiles();
  },
  methods: {
    onClose() {
      document.querySelector(
        `.sds-downloads[data-id="${this.$props.material.number}"]`
      ).style.left = "100%";
      setTimeout(() => {
        this.$emit("close", this);
      }, 500);
    },
    loadFiles() {
      if (!this.$props.material || !this.$props.material.number) return;
      let self = this;
      self.files = null;
      self.bestFile = null;
      let loader = Utils.showLoader(
        `div.sds-downloads[data-id='${this.$props.material.number}']`,
        !this.pinned
      );
      self.loading = true;
      DataLayer.getSDSFiles(this.$props.material.number)
        .then(res => {
          if (res && res.data && res.data.length > 0) {
            self.processResults(res);
            Utils.removeLoader(loader);
            self.loading = false;
          } else {
            DataLayer.getSDSFiles(this.$props.material.number.substr(0, 6))
              .then(res => {
                self.processResults(res);
                Utils.removeLoader(loader);
                self.loading = false;
              })
              .catch(err => {
                Utils.removeLoader(loader);
                self.loading = false;
                Utils.showStatusMessage(`${Labels.errorDuringSearch}. ${err}`);
              });
          }
        })
        .catch(err => {
          Utils.removeLoader(loader);
          self.loading = false;
          Utils.showStatusMessage(`${Labels.errorDuringSearch}. ${err}`);
        });
    },
    processResults(res) {
      let self = this;
      self.bestFile = null;
      let regionSet = {};
      if (res && res.data) {
        res.data.map(f => {
          /*if (f.best) {
            self.bestFile = f;
          }*/
          regionSet[f.regionName] = f.regionId;
        });
      }
      self.files = res ? res.data : [];
      this.getRegions(regionSet);
      this.setCurrentRegion(regionSet);
      this.filterFiles();
      self.$emit("loaded", self.filteredFiles.length, !!self.bestFile);
      self.$nextTick(() => self.setMaxDropdownHeight(!!self.bestFile));
    },
    getRegions(regionSet) {
      this.regions = [];
      if (!regionSet) return;
      for (let reg in regionSet) {
        if (regionSet.hasOwnProperty(reg)) {
          this.regions.push({ id: reg, name: reg });
        }
      }
      this.regions.splice(0, 0, { id: "-all-", name: Labels.anyCountry });
    },
    filterFiles() {
      this.filteredFiles = [];
      if (!this.files || this.files.length === 0) return;
      if (!this.currentRegion) return;
      this.filteredFiles = this.files.filter(x => {
        if (this.productNameMatches(x.materialName)) {
          if (this.currentRegion === "-all-") return true;
          else return x.regionName === this.currentRegion;
        } else {
          return false;
        }
      });
    },
    productNameMatches(materialName) {
      const productFirstWord = this.getFirstWord(this.$props.material.name);
      const materialFirstWord = this.getFirstWord(materialName);
      return productFirstWord === materialFirstWord;
    },
    getFirstWord(str) {
      if (!str) return "";
      const parts = str.split(" ");
      if (!parts || parts.length === 0) return "";
      const first = parts[0].trim().toLowerCase();
      const trimmedFirst = first.replace(/[^a-z1-9]/gm, "");
      return trimmedFirst;
    },
    setCurrentRegion(regionSet) {
      this.currentRegion = null;
      if (!regionSet) return;
      let countryFound = false;
      let cookieCountry = claGetCookie("CLACountry");
      if (cookieCountry) {
        let countryName = this.getCountryById(Utils.shortIdToGuid(cookieCountry));
        if (countryName && regionSet.hasOwnProperty(countryName)) {
          this.currentRegion = countryName;
          countryFound = true;
        }
      }
      if (!countryFound) {
        if (regionSet.hasOwnProperty("World")) {
          this.currentRegion = "World";
        } else {
          this.currentRegion = "-all-";
        }
      }
    },
    onRegionChanged() {
      this.filterFiles();
      this.$emit("loaded", this.filteredFiles.length, !!this.bestFile);
      this.$nextTick(() => {
        this.setMaxDropdownHeight(!!this.bestFile);
      });
    },
    setMaxDropdownHeight(hasBestFile) {
      let container = document.querySelector(
        `.sds-downloads[data-id="${this.$props.material.number}"]`
      );
      if (container) {
        let height = container.offsetHeight;
        //we also hack the region selector to not be taller than its container
        let rs = container.querySelector(`ul.options-container`);
        if (rs) {
          let rsHeight = height - (this.pinned ? 100 : (hasBestFile ? 272 : 190));
          rs.style.maxHeight = `${rsHeight}px`;
        }
      }
    },
    getCountryById(countryId) {
      if (!countryId) return "";
      let countryDropDown = document.getElementById("lst_countries_page");
      if (countryDropDown) {
        let opt = countryDropDown.querySelector(`select > option[value='${countryId}']`);
        if (opt) return opt.innerText;
      }
      return "";
    }
  },
  watch: {
    material: {
      handler() {
        console.log("Material changed");
        this.$nextTick(() => {
          this.loadFiles();
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sds-downloads:not(.pinned) {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
  left: 100%;
  background-color: white;
  box-shadow: 1px 0px 5px 1px rgba(204, 204, 204, 1);
  padding: 15px;
  display: flex;
  flex-direction: column;
  transition: left 0.5s linear;
}

.sds-downloads.pinned {
  min-height: 100px;
  position: relative;
}

.container {
  overflow: auto;
  width: 100%;
  flex-grow: 1;
  position: relative;
}

.pinned .container {
  min-height: 200px;
  overflow-x: hidden;
}

.sds-downloads.visible:not(.pinned) {
  left: 200px;
  animation: expand 0.5s;
}

@keyframes expand {
  from {
    left: 100%;
  }

  to {
    left: 200px;
  }
}

.close-panel {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='357' height='357'%3E%3Cpath fill='%23323232' d='M357 35.7L321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8z'/%3E%3C/svg%3E");
  background-size: 12px 12px;
  width: 12px;
  height: 12px;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.sds-downloads .title {
  margin-bottom: 30px;
}

.sds-downloads .title span {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-weight: 700;
  overflow-wrap: break-word;
  color: #323232;
}

.sds-downloads .title span:nth-of-type(2) {
  text-transform: uppercase;
}

.alternatives-disclaimer {
  margin: 0px 0 10px 0;
}

.best-item-disclaimer {
  margin: 0px 0px 10px 0;
}

.best-file {
  margin: 0 0 30px 0;
}

@media all and (max-width: 780px) {
  .sds-downloads:not(.pinned) {
    position: fixed;
    z-index: 1000;
    left: 100%;
    top: 0;
    right: 0;
    bottom: 0;
  }

  .sds-downloads.visible:not(.pinned) {
    left: 0;
  }

  @keyframes expand {
    from {
      left: 100%;
    }

    to {
      left: 0px;
    }
  }
}</style>